var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-container',[_c('v-row',[_c('h1',{staticStyle:{"margin-right":"20px"}},[_vm._v(" Gedenkseiten ")])]),_c('div',{staticStyle:{"margin-top":"20px"}},[_c('router-view')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }